import apiService from "./BaseApi";
const ENDPOINT = "alerts";
import store from '@/store/index'
const AlertsNotificationsService = {
    findAll: async () => apiService.post(ENDPOINT + "/notifications/findAll", { currentUserId: store.state.currentUser?.uid }),
    mapFindAll: async (filters) => apiService.post(ENDPOINT + "/maps/findAll", { currentUserId: store.state.currentUser?.uid, filters }),
    mapFindHistorical: async (filters) => apiService.post(ENDPOINT + "/maps/findHistorical", { currentUserId: store.state.currentUser?.uid, filters }),
    findByUnit: async (unit_id) => apiService.post(ENDPOINT + "/findByUnit", { currentUserId: store.state.currentUser?.uid,unit_id }),
    findGoalByUnits: async (units) => apiService.post(ENDPOINT + "/goal/findByUnits", { currentUserId: store.state.currentUser?.uid, units }),
};

export default AlertsNotificationsService;
